import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Renderer2,
  Output,
  AfterContentInit,
  AfterViewInit,
} from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { EventEmitter } from "@angular/core";
import { NotificationToastService } from "../../services/notification-toast.service";
import {
  SearchFilter,
  IFilterComponent,
} from "../../infrastructure/iFilter-component";
import { ResizedEvent } from "angular-resize-event";
import { UserFilterService } from "src/app/services/user-filter/user-filter.service";

@Component({
  selector: "app-search-filter-component",
  host: { "(document:click)": "handleClick($event)" },
  templateUrl: "./search-filter.component.html",
  styleUrls: ["./search-filter.component.css"],
})
export class SearchFilterComponent implements OnInit, AfterViewInit {
  loading = false;
  widthExp = 800;
  completingFilter: boolean;
  completingFilterClick: boolean;
  @ViewChild("entity", { static: false }) entity: ElementRef;
  @Input() noLoadOnInit: boolean;
  @Input() filter: IFilterComponent;
    @Input() canCopyFilter: boolean = false;
  @Output() endSearch = new EventEmitter();
  @Output() startSearch = new EventEmitter();
  @Output() keyup = new EventEmitter();
  @Output() copyFilter = new EventEmitter();

  constructor(
    private notificationToastService: NotificationToastService,
    private userFilterService: UserFilterService,
  ) {}

  async ngOnInit() {
    if (this.filter.setFilters() && !this.noLoadOnInit) {
      await this.search();
    }
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
  }

  ngAfterViewInit() {
    if (this.filter && this.filter.formElement) {
      this.entity.nativeElement.appendChild(
        this.filter.formElement.nativeElement,
      );
    }
  }

  openCompleteFilter(): void {
    this.completingFilter = true;
    this.completingFilterClick = true;
  }

  completeFilter(): void {
    this.completingFilter = !this.completingFilter;
    this.completingFilterClick = true;
  }

  handleClick(event) {
    if (this.completingFilter && !this.completingFilterClick) {
      let clickedComponent = event.target;
      let inside = false;
      do {
        if (
          clickedComponent &&
          clickedComponent.classList &&
          (clickedComponent.classList.contains("cdk-overlay-backdrop") ||
            clickedComponent.classList.contains("filter-container") ||
            clickedComponent.classList.contains("mat-option-text") ||
            clickedComponent.classList.contains("ng-trigger"))
        ) {
          inside = true;
        }
        clickedComponent = clickedComponent.parentNode;
      } while (clickedComponent && !inside);

      if (!inside) {
        this.completingFilter = inside;
      }
    }
    this.completingFilterClick = false;
  }

  onKeyup(event: any) {
    this.completingFilter = false;
    this.keyup.emit(event);
  }

  private getSearchFilters(): SearchFilter[] {
    const filters = this.filter.getSearchFilters();
    filters.forEach((filter) => {
      filter.onRemove.on((searchFilter) => {
        this.filter.form.get(searchFilter.key).setValue(null);
        this.search();
      });
    });

    return filters;
  }

  async search() {
    let items: any;
    try {
      this.completingFilter = false;
      this.loading = true;
      this.startSearch.emit();
      this.filter.saveFilters();
      items = await this.filter.search();
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Búsqueda",
      );
    } finally {
      this.endSearch.emit({
        items: items,
        searchFilters: this.getSearchFilters(),
      });
      this.loading = false;
    }
  }
}
